import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import FormSelect from '../../../../../Components/Form/FormSelect';
import FormRadioStack from '../../../../../Components/Form/FormRadioStack';
import keysToLowerCase from '../../../../../Helpers/keysToLowerCase';

const DefaultExtensionData = function DefaultExtensionData({
  errors,
  watch,
  defaultData = {},
  setValue,
  activityTypes,
}) {
  const intl = useIntl();
  const extensionData = keysToLowerCase(
    JSON.parse(defaultData?.extensionData || '{}')
  );
  const defaultValues = {
    ...extensionData,
    shouldSync: extensionData?.shouldSync ? 'YES' : 'NO',
  };

  const shouldSyncWatch = watch && watch('nextActType');
  const shouldSyncValueWatch = watch && watch('shouldSync');

  useEffect(() => {
    if (typeof shouldSyncValueWatch === 'string') {
      setValue('shouldSync', shouldSyncValueWatch === 'YES');
    }
  }, [shouldSyncValueWatch, setValue]);

  return (
    <>
      <Grid size={6}>
        <FormSelect
          name="nextActType"
          options={[
            { label: '- - -', value: '' },
            ...(activityTypes || []).map(({ id, name }) => ({
              label: intl.messages[name?.toUpperCase()] || name,
              value: id,
            })),
          ]}
          error={errors?.nextActType}
          defaultValue={defaultValues.nextActType}
        />
      </Grid>
      {shouldSyncWatch && (
        <Grid size={6}>
          <FormRadioStack
            name="shouldSync"
            row
            options={['YES', 'NO']}
            error={errors?.shouldSync}
            defaultValue={defaultValues.shouldSync}
          />
        </Grid>
      )}
    </>
  );
};
export default DefaultExtensionData;
